module.exports = __webpack_public_path__ + "static/design-pc-5-ad4fe590c8b8880b5da8cec570787f5f.png";